export enum CertificateStatus {
    Current = 0,
    Expired = 1,
    Ordered = 2,
    Archived = 4
}